import React from "react";
import Footer from "./footer";
import Header from "./header";

const Layout = ({ children }) => {
  // Check if the current page is the FileViewerPage
  const isFileViewerPage = children?.type?.name === "FileViewerPage";

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header - Only show if not FileViewerPage */}
      {!isFileViewerPage && (
        <header className="fixed bottom-0 left-0 right-0">
          <Header />
        </header>
      )}
      {/* Main content wrapper */}
      <div className={`flex-1 ${!isFileViewerPage ? "mb-[64px]" : ""}`}>
        {children}
      </div>
      {/* Footer - Only show if not FileViewerPage */}
      {!isFileViewerPage && (
        <footer className="fixed bottom-0 left-0 right-0">
          <Footer />
        </footer>
      )}
    </div>
  );
};

export default Layout;
